import {defaultConfiguration, defaultConfigurationModules, IConfiguration} from "../configuration.state";
const CONFIGURATION_RENAISSANCE:IConfiguration = {
  ...defaultConfiguration,
  api: {
    ...defaultConfiguration.api,
    protocol: 'https',
    port: '443'
  },
  theme: 'renessans',
  language: {
    defaultLang: 'ru',
    showLang: false,
    langList: ['en', 'ru', 'ro', 'ua']
  },
  pagesConfig: {
    ...defaultConfigurationModules,
    login:{
      ...defaultConfigurationModules.login,

      loginType: 'common',
      goFAQ: '',
      supportEmail: 'support@redfactory.io',
      enableSelfRegistration: true,
      enableGoogleSignIn: true,
      showTutorialVideo: false,
      showTryDemoButton: true,
      showAboutUsButton: true,
      showContacts: true,
      showContactOnlyEmail: true,

      contactsConfig: {
        showViber: false,
        showPhone: false,
        showEmail: true
      }
    },
    main:{
      showSupportBlock: false
    },
    dataLedger: {
      ...defaultConfigurationModules.dataLedger,
      showAddressForPartner: true
    }
  }
};

export const CONFIGURATION_RENAISSANCE_DEV:IConfiguration = {
  ...CONFIGURATION_RENAISSANCE
};
export const CONFIGURATION_RENAISSANCE_PROD:IConfiguration = {
  ...CONFIGURATION_RENAISSANCE
};
